import { createContext, useEffect, useMemo, useRef, useState } from "react"
import * as PropTypes from "prop-types"
import orderBy from "lodash/orderBy"

export const CarContext = createContext({})

function CarContextProvider({ children, car, cars, slug, page, initialData, extraImages, footerLinks }) {
  const formRef = useRef(null)
  const plansRef = useRef(null)
  const mobileCtaRef = useRef(null)
  const plans = useMemo(() => orderBy(car.priceRanges, [plan => plan.price], ["asc"]), [car])
  const [selectedPlan, setSelectedPlan] = useState(plans.length > 0 ? plans[0] : {})
  const [showMedia, setShowMedia] = useState(false)
  const [withoutTaxes, setWithoutTaxes] = useState(false)

  useEffect(() => {
    const { youtubeId, panoramaConfig } = car

    const updateMedia = () => {
      const { hash } = window.location

      if (hash === "#video" && youtubeId) setShowMedia("video")
      else if (hash === "#panorama" && panoramaConfig?.enabled) setShowMedia("panorama")
    }

    updateMedia()

    window.addEventListener("hashchange", updateMedia)

    return () => window.removeEventListener("hashchange", updateMedia)
  }, [car])

  const setMinPlan = () => {
    const minPrice = plans.length > 0 ? plans[0] : {}
    if (minPrice) setSelectedPlan(minPrice)
  }

  useEffect(setMinPlan, [plans])

  return (
    <CarContext.Provider
      value={{
        car,
        cars,
        slug,
        plans,
        selectedPlan,
        setSelectedPlan,
        setMinPlan,
        formRef,
        plansRef,
        mobileCtaRef,
        page,
        showMedia,
        setShowMedia,
        initialData,
        extraImages,
        withoutTaxes,
        setWithoutTaxes,
        footerLinks
      }}>
      {children}
    </CarContext.Provider>
  )
}

CarContextProvider.defaultProps = {
  page: "car_data",
  initialData: {},
  extraImages: [],
  footerLinks: []
}

CarContextProvider.propTypes = {
  page: PropTypes.string,
  car: PropTypes.object.isRequired,
  slug: PropTypes.object.isRequired,
  cars: PropTypes.array.isRequired,
  footerLinks: PropTypes.array,
  children: PropTypes.node.isRequired,
  initialData: PropTypes.object,
  extraImages: PropTypes.arrayOf(PropTypes.string)
}

export default CarContextProvider


